<p>
  dialog-producto works!
</p>
